import { formatDateParam, resolveDateFilter } from './dateRange'
import type { DateFilter, DatePreset, UsageFiltersState } from './types'

import type { ComparisonMode, TeamInsightsFilterParams } from '@/api/teamInsights'

export const todayIso = () => new Date().toISOString().slice(0, 10)

// Tells the backend which pct_change branch to use when the wire shape is
// ambiguous (e.g. ``start=day 1, end=day 7`` is both "Last 7 days" on the 7th
// and "This month" on the 7th). Custom ranges leave it ``undefined`` so the
// backend falls back to shape detection.
const COMPARISON_MODE_BY_PRESET: Record<DatePreset, ComparisonMode | undefined> = {
  all: undefined,
  '7d': 'rolling',
  '30d': 'rolling',
  this_month: 'calendar',
  last_month: 'calendar',
  this_year: 'calendar',
}

const comparisonModeFor = (filter: DateFilter): ComparisonMode | undefined =>
  filter.kind === 'preset' ? COMPARISON_MODE_BY_PRESET[filter.preset] : undefined

// Sort + dedupe so identical selections in different click orders share one
// React Query cache entry and one outbound URL. Backend canonicalizes too
// (see ``TeamInsightsFilters._sort_filter_lists``) — this is purely for client
// cache-key stability.
const canonicalList = (values: string[]): string[] | undefined =>
  values.length ? Array.from(new Set(values)).sort() : undefined

export const filtersToParams = (filters: UsageFiltersState): TeamInsightsFilterParams => {
  const { start, end } = resolveDateFilter(filters.date)
  return {
    start_date: start ? formatDateParam(start) : undefined,
    end_date: end ? formatDateParam(end) : undefined,
    team_id: filters.teamId ?? undefined,
    user_ids: canonicalList(filters.userIds),
    app_keys: canonicalList(filters.appKeys),
    app_categories: canonicalList(filters.appCategories),
    comparison_mode: comparisonModeFor(filters.date),
  }
}
